module.exports = __webpack_public_path__ + "img/index.42ab3017.jpg";